"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DefaultDBErrorExtractor", {
    enumerable: true,
    get: function() {
        return DefaultDBErrorExtractor;
    }
});
const _nocodbsdk = require("nocodb-sdk");
let DefaultDBErrorExtractor = class DefaultDBErrorExtractor {
    extract(error) {
        var // log error for unknown error code
        _this_option_dbErrorLogger, _this_option, _error_message;
        if (!error.code) return;
        let message;
        let _extra;
        let _type;
        const httpStatus = 422;
        (_this_option = this.option) == null ? void 0 : (_this_option_dbErrorLogger = _this_option.dbErrorLogger) == null ? void 0 : _this_option_dbErrorLogger.error(error);
        // if error message contains -- then extract message after --
        if ((_error_message = error.message) == null ? void 0 : _error_message.includes('--')) {
            message = error.message.split('--')[1];
        }
        return {
            error: _nocodbsdk.NcErrorType.ERR_DATABASE_OP_FAILED,
            message,
            code: error.code,
            httpStatus
        };
    }
    constructor(option){
        this.option = option;
    }
};
